import React from 'react';
import { File as ParsedDiffFile } from '@/types/parse-diff';
import DiffStatsBar from './DiffStatsBar';
import FileDiff from './FileDiff';

interface DiffViewProps {
  files: ParsedDiffFile[];
  rawDiff: string | null;
}

const DiffView: React.FC<DiffViewProps> = ({ files, rawDiff }) => {
  if (files.length === 0) {
    return (
      <div className="p-4 mt-4 text-sm border rounded-md bg-muted/20 text-muted-foreground">
        <p className="mb-2 font-semibold">No file changes to display.</p>
        <p>
          This may be due to only metadata changes (e.g., file mode) or an
          empty diff.
        </p>
        <details className="mt-2 text-xs">
          <summary>View raw diff</summary>
          <pre className="mt-2 whitespace-pre-wrap">{rawDiff}</pre>
        </details>
      </div>
    );
  }

  return (
    <div className="mt-4 space-y-4">
      <DiffStatsBar files={files} />
      {files.map((file, fileIndex) => (
        <FileDiff key={fileIndex} file={file} />
      ))}
    </div>
  );
};

export default DiffView;
